// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"fQ","border":"fR"};